// extracted by mini-css-extract-plugin
export default {"product-search":"ProductSearch_product-search__kkf24","product-search-overlay-popover":"ProductSearch_product-search-overlay-popover__7Nbw9"};